// extracted by mini-css-extract-plugin
module.exports = {"Features":"ProductDetailsPage_Features__2OXJK"};